import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectViewSegmentSelected = createSelector(
  [(store: RootState) => store.paymentNoticeDetail.viewSegmentSelected],
  (viewSegmentSelected) => viewSegmentSelected
);
